////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const salesHistoryManager = {
	getSalesHistory: (filters = {}, queryParams = { page: '0', size: '250', sort: 'date', nameDir: 'desc' }) => ({
		type: ActionsTypes.GET_SALES_HISTORY,
		payload: {
			filters,
			queryParams,
		},
	}),
	getSalesHistorySuccess: (data) => ({
		type: ActionsTypes.GET_SALES_HISTORY_SUCCESS,
		payload: {
			data,
		},
	}),
	getSalesHistoryFailure: (error) => ({
		type: ActionsTypes.GET_SALES_HISTORY_FAILURE,
		payload: {
			error,
		},
	}),
	sendMerchantTicket: (id) => ({
		type: ActionsTypes.SEND_MERCHANT_TICKET,
		payload: {
			id,
		},
	}),
	sendMerchantTicketSuccess: (response) => ({
		type: ActionsTypes.SEND_MERCHANT_TICKET_SUCCESS,
		payload: {
			response,
		},
	}),
	sendMerchantTicketFailure: (error) => ({
		type: ActionsTypes.SEND_MERCHANT_TICKET_FAILURE,
		payload: {
			error,
		},
	}),
	sendGuestTicket: (id, data) => ({
		type: ActionsTypes.SEND_GUEST_TICKET,
		payload: {
			id,
			data,
		},
	}),
	sendGuestTicketSuccess: (response) => ({
		type: ActionsTypes.SEND_GUEST_TICKET_SUCCESS,
		payload: {
			response,
		},
	}),
	sendGuestTicketFailure: (error) => ({
		type: ActionsTypes.SEND_GUEST_TICKET_FAILURE,
		payload: {
			error,
		},
	}),
	setTransactionNumber: (transactionNumber) => ({
		type: ActionsTypes.SET_TRANSACTION_NUMBER,
		payload: {
			transactionNumber,
		},
	}),
	resetTransactionNumberConsignation: () => ({
		type: ActionsTypes.RESET_TRANSACTION_NUMBER_CONSIGNATION,
	}),
	resetTransactionItems: () => ({
		type: ActionsTypes.RESET_TRANSACTION_ITEMS,
	}),
	setTelecollectId: (telecollectId) => ({
		type: ActionsTypes.SET_TELECOLLECT_ID,
		payload: {
			telecollectId,
		},
	}),
	setPromotionNumber: (promotionNumber) => ({
		type: ActionsTypes.SET_PROMOTION_NUMBER,
		payload: {
			promotionNumber,
		},
	}),
}

export default salesHistoryManager
